/**
 * @desc: 通道反馈
 * @created: 2020/6/2
 * @author: Colorfule
 * @version: v1.0
 */

import request from '@/plugins/http'

// 获取列表数据
export const getListData = params => {
  return request.get('/paymentfeedback/list', params)
}

// 获取通道信息详情
export const getPaymentDetails = params => {
  return request.get('/paymentfeedback/details', params)
}
